import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const detailedStatisticsContainer = style({
  display: 'grid',

  ...responsiveStyle({
    mobile: {
      gridTemplateColumns: '1fr',
    },
    wide: {
      gridAutoFlow: 'column',
      gridAutoColumns: '1fr',
    },
  }),
});

export const detailedStatisticsSection = style({
  display: 'flex',
  gap: space.s20,

  ...responsiveStyle({
    mobile: {
      flexDirection: 'column',
      borderBottom: `1px solid ${themeVars.container.border.default}`,
      padding: `${space.s20}px 0`,

      ':last-child': {
        borderBottom: 0,
        padding: `${space.s20}px 0 0`,
      },
    },
    tablet: {
      flexDirection: 'row',
    },
    wide: {
      flexDirection: 'column',
      padding: `0 ${space.s20}px`,
      borderRight: `1px solid ${themeVars.container.border.default}`,
      borderBottom: 0,

      ':last-child': {
        padding: `0 ${space.s20}px`,
        borderRight: 0,
      },
    },
  }),
});

export const detailedStatisticsBlock = style({
  ...responsiveStyle({
    tablet: {
      flexBasis: '50%',
    },
    wide: {
      flexBasis: 'auto',
    },
  }),
});

export const blockHeading = style({
  ...responsiveStyle({
    mobile: {
      ...typography['titleMd'],
    },
    tablet: {
      ...typography['bodyMd'],
    },
  }),
});
